import { Island } from '../island.class';
import { IslandType } from '../enums';
import { determineIslandTypeCfn } from './determine-island-type.cfn';

/**
 * Calculates island name based on type and size
 * @param island Island to calculate the base size for
 * @returns string
 */
export const getIslandDescriptionCfn = (island: Island): string => {
	determineIslandTypeCfn(island);
	// linearFeet matches the length hardcoded into the sku by getIslandSkuCfn (Corner=5, Pizza/Asado=3)
	const key = island.linearFeet;

	let heightType = '';
	switch (island.type) {
		case IslandType.Asado:
			heightType = `${key}ft Asado Stand`;
			break;
		case IslandType.Corner:
			heightType = `${key}ft Corner Stand`;
			break;
		case IslandType.Pizza:
			heightType = `${key}ft Pizza Stand`;
			break;
		case IslandType.Smoker:
			heightType = `${key}ft Smoker Stand`;
			break;
		case IslandType.Bar:
			heightType = `${key}ft Bar Island`;
			break;
		default:
			heightType = `${key}ft Grill Island`;
			break;
	}

	return `${heightType} | Base Length ${island.size.width}" | Island Height ${island.size.height}"`;
};
